import classnames from 'classnames';

import useStyles from './styles';
import type { SpinnerProps } from './types';

const Spinner = ({ size = 'medium', className }: SpinnerProps) => {
  const classes = useStyles();

  return (
    <div
      className={classnames(classes.spinner, className, {
        [classes.xsmall]: size === 'xsmall',
        [classes.small]: size === 'small',
        [classes.large]: size === 'large',
      })}
    />
  );
};

export default Spinner;
